import { BaseSeasonCardElementMixin } from "%/dynamic-component-editor/standard-components/base-season-card/base-season-card-element-mixin";

export const SeasonCardSmallElementMixin = {
  extends: BaseSeasonCardElementMixin,
};
